import React, { useEffect, useState } from 'react';
import { useGetBeneficiarQuery } from 'redux/Api/beneficiariesApi/beneficiariesApi';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Layout } from 'features/Layouts/Layouts';
import { RootState } from 'redux/store';
import { setInfoBeneficiar } from 'redux/beneficiarDetail/slice';
import { TabBeneficiaries } from 'components/TabBeneficiaries';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { Nothing } from 'components/Nothing';
import { ReactComponent as DocSvg } from './img/icon_document.svg';
import styles from './BeneficiariesDetails.module.scss';
import CastomerDataForm from './CastomerDataForm';
import CastomerCommissionForm from './CastomerCommissionForm';
import CustomerOrderAmountForm from './CustomerOrderAmountForm';
import FeaturesWorkSupport from './FeaturesWorkSupport';

export const BeneficiariesDetails = () => {
  const { id } = useParams();
  const { data, isLoading, error, refetch } = useGetBeneficiarQuery({
    beneficiary_id: Number(id),
  });
  const { infoBeneficiar } = useSelector((state: RootState) => state.beneficiarSlice);
  const dispatch = useDispatch();
  const [modalCustomerOpen, setModalCustomerOpen] = useState(false);
  const [modalCommissionOpen, setModalCommissionOpen] = useState(false);
  const [modalLimitOpen, setModalLimitOpen] = useState(false);

  useEffect(() => {
    if (data) {
      for (const key in data) {
        dispatch(
          setInfoBeneficiar({
            key,
            value: (data as Record<string, unknown>)[key],
            step: false,
            secondKey: '',
          }),
        );
      }

      if (data.director?.email) {
        dispatch(
          setInfoBeneficiar({
            key: 'email',
            value: data.director.email,
            step: false,
            secondKey: '',
          }),
        );
      }
      if (data.director?.phone) {
        dispatch(
          setInfoBeneficiar({
            key: 'phone',
            value: data.director.phone,
            step: false,
            secondKey: '',
          }),
        );
      }
    }
  }, [data, id, dispatch]);

  if (error) {
    return (
      <Layout>
        <Nothing
          style={{ height: '700px', marginTop: '30px' }}
          title='Ничего не найдено'
        />
      </Layout>
    );
  }

  return (
    <Layout>
      {isLoading ? (
        <LoadingSkeleton mt />
      ) : (
        <div className={styles.root}>
          <div className={styles.back}>
            <p className={styles.back_title}>{data?.customer?.jur_name}</p>
          </div>
          <div className={styles.content}>
            <div className={styles.rootleft}>
              <CastomerDataForm
                data={data}
                id={id}
                modalCustomerOpen={modalCustomerOpen}
                setModalCustomerOpen={setModalCustomerOpen}
                refetch={refetch}
              />
              {infoBeneficiar?.beneficiary?.document && (
                <div className={styles.left}>
                  <p style={{ marginBottom: '10px' }} className={styles.title}>
                    Документы
                  </p>
                  <div className={styles.doc}>
                    <DocSvg />
                    <a
                      style={{ cursor: 'pointer' }}
                      href={infoBeneficiar.beneficiary.document?.file}
                      download
                      target='_blank'
                      rel='noreferrer'>
                      {infoBeneficiar.beneficiary.document?.document_number} от{' '}
                      {infoBeneficiar.beneficiary.document?.document_date}
                    </a>
                  </div>
                </div>
              )}
              <CastomerCommissionForm
                id={id}
                modalCommissionOpen={modalCommissionOpen}
                setModalCommissionOpen={setModalCommissionOpen}
                refetch={refetch}
              />
              <CustomerOrderAmountForm
                id={id}
                modalLimitOpen={modalLimitOpen}
                min_limit={infoBeneficiar?.order_limits?.min ?? 0}
                max_limit={infoBeneficiar?.order_limits?.max ?? 0}
                setModalLimitOpen={setModalLimitOpen}
                refetch={refetch}
              />
              <FeaturesWorkSupport features={data?.features || {}} id={data?.id ?? 0} />
            </div>

            <div className={styles.right}>
              {infoBeneficiar?.id && infoBeneficiar && <TabBeneficiaries />}
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};
